<template>
  <div>
    <h3 ref="intro">
      Straight Lines: What Are They?
    </h3>
    <p>
      A straight line is a geometric shape that forms the shortest path two points.
    </p>
    <h3 ref="graph1">
      MagicGraph | A Straight Line is the Shortest Path between Two Points
    </h3>
    <v-responsive>
      <v-layout justify-center>
        <div id="jxgbox2" class="edliy-box-about" />
      </v-layout>
    </v-responsive>
    <h3 ref="sol">
      Equation of a Straight Line
    </h3>
    <p>
      The general form of the equation representing a straight line is:
      $$y = mx +c $$
      where \(m\) is the slope and \(c\) is the intercept formed by the line on y-axis.
    </p>
    <h3 ref="graph2">
      MagicGraph | Slope & Intercept of a Straight Line
    </h3>
    <p />
    <v-responsive>
      <v-layout justify-center>
        <div id="jxgbox1" class="edliy-box-about" />
      </v-layout>
    </v-responsive>
  </div>
</template>
<script>
import Boxes from './Boxes.js'
export default {
  name: 'StraightLine',
  created: function () {
    this.$store.commit('navigation/resetState');
    // Store mutations
    const title = 'Straight Line';
    this.$store.commit('navigation/changeTitle', title);
    this.$store.commit('navigation/changeMenu', title);
    const newTopics = [
      {title: 'Straight Line', img:'/assets/number-1.svg', action: () => this.goto('intro')},
      {title: 'MagicGraph: Shortest Path Connecting Two Points', img:'/assets/touch.svg', action: () => this.goto('graph1')},
      {title: 'Equation of Straight Line', img:'/assets/number-2.svg', action: () => this.goto('sol')},
      {title: 'MagicGraph: Equation of a Straight Line ', img:'/assets/touch.svg', action: () => this.goto('graph2')}
    ];
    this.$store.commit('navigation/replaceTopics', newTopics);
    const newMath =true;
    this.$store.commit('navigation/replaceMath', newMath);
    const newshowhome = false;
    this.$store.commit('navigation/toggleshowhome', newshowhome);
    const newLeftArrow =true;
    this.$store.commit('navigation/replaceLeftArrow', newLeftArrow);
    const newModule=true;
    this.$store.commit('navigation/replaceModule', newModule);
  },
  mounted () {
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    Boxes.box1();
    Boxes.box2();
  },
  metaInfo() {
  return{ title: 'Lines',
          //titleTemplate: '%s - Learn interactively',
          meta: [ {vmid: 'viewport', name: 'viewport', content: 'width=device-width, initial-scale=1'},
                  {vmid: 'description', name: 'description', content: 'Learn interactively about lines.'}
                ]
        }
   },
}
</script>

<style lang="scss">
@import 'src/styles/edliy-box.scss';
@import 'src/styles/subtopic-menu.scss';
@import 'src/styles/edliy-box-about.scss';
@import 'src/styles/screen-sizes.scss';
</style>
